import { ReactNode } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useNotification } from './shared/notification/useNotification';
import { behClient } from './api/beh-api';

interface AppContainerProps {
  readonly children: ReactNode;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: Infinity
    }
  }
});

export function AppContainer({ children }: AppContainerProps) {
  const { notifyUserFromRequest } = useNotification();
  queryClient.setDefaultOptions({
    queries: {
      queryFn: ({ queryKey }) =>
        notifyUserFromRequest(() => behClient.get(queryKey.at(0) as string)),
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: Infinity
    }
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
